import { AnchorButton, Intent } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { TEST_IDS, getNotificationTestId } from 'src/common/constants/testIds';
import { StacktraceInfo } from 'src/common/reducers/notifications';
import * as copy from 'src/common/templates/copy';
import { isClipboardEnabled } from 'src/common/utils/isClipboardEnabled';

type ErrorNotificationMessageProps = {
  notificationId: string;
  message: string;
  stackTraceInfo?: StacktraceInfo;
};

export const ErrorNotificationMessage: React.VFC<ErrorNotificationMessageProps> =
  ({ notificationId, message, stackTraceInfo }) => {
    const [isCopyClicked, setIsCopyClicked] = React.useState(false);
    const [isDownloadClicked, setIsDownloadClicked] = React.useState(false);
    const [downloadUrl, setDownloadUrl] = React.useState('');
    const testId = getNotificationTestId(notificationId);
    const newlines = '\n\n\n';

    React.useEffect(() => {
      const downloadUrl = stackTraceInfo
        ? URL.createObjectURL(
            new Blob(
              [
                stackTraceInfo.stackTrace,
                newlines,
                stackTraceInfo.stackTraceBinary,
              ],
              {
                type: 'text/plain',
              }
            )
          )
        : '';

      setDownloadUrl(downloadUrl);

      return () => {
        if (downloadUrl) {
          URL.revokeObjectURL(downloadUrl);
        }
      };
    }, [stackTraceInfo]);

    return (
      <>
        <div className="sd-toast-actionable-message" data-testid={testId}>
          <span className={classNames('sd-toast-error-message', 'selectable')}>
            {message}
          </span>
        </div>
        <div className="sd-toast-actionable-actions">
          {stackTraceInfo ? (
            <AnchorButton
              data-testid={TEST_IDS.notification.errorDownloadStacktraceButton}
              download={`${stackTraceInfo.timeStamp}.txt`}
              href={downloadUrl}
              intent={Intent.DANGER}
              minimal
              onClick={() => {
                setIsDownloadClicked(true);
              }}
              rel="noreferrer"
              target="_blank"
              text={
                !isDownloadClicked
                  ? copy.components.notifications.error.download
                  : copy.components.notifications.error.downloaded
              }
            />
          ) : null}
          {isClipboardEnabled() ? (
            <AnchorButton
              data-testid={TEST_IDS.notification.errorCopyButton}
              intent={Intent.DANGER}
              minimal
              onClick={() => {
                setIsCopyClicked(true);
                navigator.clipboard.writeText(message);
              }}
              text={
                !isCopyClicked
                  ? copy.components.notifications.error.copy
                  : copy.components.notifications.error.copied
              }
            />
          ) : null}
        </div>
      </>
    );
  };
